import styled from 'styled-components';
import { Divider } from 'antd';
import { SectionLastHeading } from "../../../../../../../../CommonComponents/commonStyles";

export const ContribType = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.textColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`;

export const ContributionName = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.headingColor};
word-break: break-all;
margin-right: 5px;
padding-bottom:${props => props.paddingBottom};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  overflow-wrap: break-word;
  padding-bottom:0px;
}
`;

export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: ${props => props.top};
     margin-bottom: ${props => props.bottom};
     background: #d4d4d4;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  &&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-bottom: ${props => props.mobileBottom};
     margin-top: ${props => props.mobileTop ? props.mobileTop : '10px'};
     background: #d4d4d4;
}
}
`;

export const SectionHeading = styled(SectionLastHeading)`
margin-bottom: 20px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.mobileFont};

}
`;
